import type { TablePaginationConfig } from 'antd/lib/table/interface';

import { showTotal } from '../utils';

const FIRST_PAGE = 1;
const NONE = 0;

interface BuildPaginationOptionsParams {
	page: number;
	limit: number;
	total?: number;
	onPageChange: (page: number) => void;
}

export function buildPaginationOptions({
	page,
	limit,
	total = NONE,
	onPageChange
}: BuildPaginationOptionsParams): TablePaginationConfig {
	const options: TablePaginationConfig = {
		showTotal,
		hideOnSinglePage: false,
		showSizeChanger: false,
		total,
		current: page === NONE ? FIRST_PAGE : page,
		defaultPageSize: limit,
		pageSize: limit,
		onChange: onPageChange
	};

	return options;
}
